import { resolveFunnelConfig } from '../../funnels/funnelConfig';

export type { FunnelConfig, FunnelHomePageConfig } from '../../funnels/funnelConfig';

export function useFunnelConfig() {
  const funnel = useFunnelContext();
  return computed(() => resolveFunnelConfig(funnel.value));
}
